import selectGraphType from '../handlers/select-graph-type'

onDomLoad(function () {
  document
    .querySelectorAll('[data-behaviour~="report-graph"]')
    .forEach((el) => {
      const graphType = selectGraphType(el.dataset['graphType'])
      const graph = new graphType(JSON.parse(el.dataset['graphData']))
      graph.render(el)
    })
})
